import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { ChartWithBackgroundOptions } from './chart-with-background';

const dateLabels = [
  'Sunday',
  'Saturday',
  'Friday',
  'Thursday',
  'Wednesday',
  'Tuesday',
  'Monday',
] as const;

export const visitsByDayOfWeekChartData = (
  visitsByDayOfWeek: CampaignAnalyticsReport['visitsByDayOfWeek']
): ChartWithBackgroundOptions['chartData'] =>
  visitsByDayOfWeek.visible
    ? [
        visitsByDayOfWeek.data.sunday,
        visitsByDayOfWeek.data.saturday,
        visitsByDayOfWeek.data.friday,
        visitsByDayOfWeek.data.thursday,
        visitsByDayOfWeek.data.wednesday,
        visitsByDayOfWeek.data.tuesday,
        visitsByDayOfWeek.data.monday,
      ].map((value, index) => ({
        name: dateLabels[index] ?? 'Unknown',
        value,
      }))
    : [];
